import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import ReadAxios from '../axiosComponent/read';


const MyProducts = ({
  field: { name },
  form: { setFieldValue },
  disabled,
  ...props
}) => {
  const [contents, setcontents] = useState([])
  const [isloading, setisloading] = useState(true)
  useEffect(() => {
    if(!disabled) {
      let locations = ReadAxios({ url: 'skuMaster' }) || [];
      locations.then((res) => {
        setcontents(res.data.resultSet)
        setisloading(false)
      })
    } else {
      setisloading(false)
    }
  }, [])

  let options = []
  if (contents.length > 0) {
    contents.map((object, index) => {
      let temp = {}
      temp.key = index + 1
      temp.text = props.showNameAndCode ? `${object.skuName} (${object.skuCode})` : object.skuCode
      temp.value = props.idValue ? object.skuMasterId : object.skuCode
      return options[index] = temp
    })
  }
  return (
    <Dropdown
      selection
      loading={isloading}
      style={{ width: "100%" }}
      // search
      onChange={(value, data) => {
        setFieldValue(name, data.value)
        if (props?.setName) {
          contents.forEach(element => {
            if (element.skuCode == data.value) {
              setFieldValue(props.setName, element.skuName)
            }
          });
        }
      }}
      options={options}
      disabled={disabled}
      {...props}
    />

  )
}

export default MyProducts